import { defineComponent as l, openBlock as r, createBlock as c, unref as a, mergeProps as p, withCtx as d, createElementVNode as t } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ l({
  name: "IconBellOutlined",
  __name: "IconBellOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (u, e) => (r(), c(a(i), p(o, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        t("path", {
          "fill-rule": "evenodd",
          d: "M12 2.125c-1.774 0-3.485.657-4.755 1.842C5.937 5.188 5.25 7.23 5.25 8.875v3.5c0 1.836-.893 2.485-1.268 2.69C3.61 15.27 3.25 15.69 3.25 16.253v.123a1.25 1.25 0 0 0 1.25 1.25h15a1.25 1.25 0 0 0 1.25-1.25V16.24c0-.547-.343-.963-.708-1.17-.388-.22-1.292-.899-1.292-2.694v-3.5c0-1.646-.687-3.687-1.995-4.908-1.27-1.184-2.982-1.842-4.755-1.842m-5.25 6.75c0-1.324.577-2.932 1.519-3.811.981-.918 2.323-1.44 3.731-1.44s2.749.523 3.731 1.439c.942.879 1.519 2.487 1.519 3.811v3.5c0 2.073.933 3.196 1.673 3.75H5.102c.744-.553 1.648-1.668 1.648-3.75v-3.5",
          "clip-rule": "evenodd"
        }, null, -1),
        t("path", { d: "M10.76 19.282a.75.75 0 0 0-1.489.186 2.75 2.75 0 0 0 5.458 0 .75.75 0 1 0-1.489-.186 1.25 1.25 0 0 1-2.48 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
